module.exports = "pegasus/assets/hexline-facebook.gif";